import { InjectProperty } from '@jack-henry/frontend-utils/di';
import { NavigationService } from '@treasury/core/navigation';
import { AccountService } from '@treasury/domain/account';
import { LoginService } from '@treasury/domain/channel/services';
import { CurrentUser } from '@treasury/domain/user/current-user.entity';
import { NotificationService, TmBaseComponent } from '@treasury/presentation';
import { userIcon } from '@treasury/presentation/assets/icons';
import '@treasury/presentation/components/tm-loader';
import { SessionStorageService } from '@treasury/utils';
import { css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import '../../components/jhd-tooltip';

export const tagName = 'profile-header-item';
@customElement(tagName)
export class ProfileHeaderItem extends TmBaseComponent {
    @property()
    public lastLogin = '';

    @state()
    private currentUser?: CurrentUser;

    @InjectProperty()
    declare private navService: NavigationService;

    @InjectProperty()
    declare private loginService: LoginService;

    @InjectProperty()
    declare private sessionStorage: SessionStorageService;

    @InjectProperty()
    declare private readonly notificationService: NotificationService;

    @InjectProperty()
    declare private accountService: AccountService;

    @state()
    private loading = false;

    protected async firstUpdated() {
        this.loading = true;
        try {
            this.lastLogin = await this.loginService.getLastLogin();
            this.currentUser = await this.accountService.getCurrentUser();
        } catch {
            this.notificationService.renderError('Error fetching user information');
        }
        this.loading = false;
    }

    protected render() {
        if (this.loading) {
            return html`<tm-loader reversed></tm-loader>`;
        }
        return html`<tm-icon
                class="lg:hidden"
                color="var(--jh-color-gray-0)"
                .icon=${userIcon}
            ></tm-icon>
            <li
                class="user-profile-item hidden lg:flex items-center px-2.5 py-1.5 text-light border-l"
                @keyup=${(event: KeyboardEvent) => this.handleKeyUp(event)}
                @click=${() => {
                    this.navService.navigate(`/profile`);
                }}
            >
                <div class="user-badge size-9 rounded-full mr-2 bg-brand-darker text-xl leading-9">
                    ${this.currentUser?.name.charAt(0).toUpperCase()}
                </div>
                <div class="user-data flex flex-col items-start">
                    <div class="user-name text-base">${this.currentUser?.name}</div>
                    <div class="user-info text-xs">Last Login: ${this.lastLogin}</div>
                </div>
            </li>`;
    }

    private handleKeyUp(event: KeyboardEvent) {
        const { key } = event;
        if (key === 'Return') {
            this.navService.navigate(`/profile`);
        }
    }

    public static get styles() {
        return [
            css`
                :root {
                    display: block;
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: ProfileHeaderItem;
    }
}
